export const GetAllAccessLevels = "/access_manager/all_access_levels";
export const GetUserAccessLevel = "access_manager/get_user_access_levels";
export const UpdateUserAccessLevel = "/access_manager/update_access_level";
export const AddAccessLevelToUser = "/access_manager/add_access_level_to_user";
export const RemoveUserAccessLevel = "/access_manager/delete_access_level";
export const CreateAccessLevel = "/access_manager/create_access_level";
